import axios from "axios";
import { toast } from "react-hot-toast";
import { getApi } from "../backend";

export const getOpportunities = async (page, approved, limit = 10) => {
  return await axios.get(
    `${getApi()}/api/v1/opportunity/get?page=${page}&limit=${limit}&approved=${approved}`
  );
};

export const getOppbyId = async (id) => {
  return await axios.get(`${getApi()}/api/v1/opportunity/get/${id}`);
};

export const deleteOpp = async (id) => {
  return await axios.delete(`${getApi()}/api/v1/opportunity/delete/${id}`);
};

export const approveOpp = async (id, value) => {
  return await axios.put(
    `${getApi()}/api/v1/opportunity/approve/${id}`,
    {
      value: value,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

export const getCreatorForms = () => {
  return fetch(`${getApi()}/api/v1/creatorform/get`, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const acceptCreatorFrom = async (body, id) => {
  return fetch(`${getApi()}/api/v1/creator/accept/${id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};
// export const approveOpportunity = async (body, id) => {
//   return fetch(`${getApi()}/api/v1/creator/accept/${id}`, {
//     method: "POST",
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(body),
//   })
//     .then((response) => {
//       return response.json();
//     })
//     .catch((err) => console.log(err));
// };

export const rejectCreatorFrom = async (body, id) => {
  return fetch(`${getApi()}/api/v1/creator/reject/${id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};
